import { Tabs, TabsList, TabsTrigger } from 'lib/components/tabs'
import { useBillingPlans } from './billing-plans-context'

export default function BillingModalPeriod() {
  const { period, setPeriod } = useBillingPlans()

  return (
    <Tabs defaultValue={period}>
      <div className="tw-flex tw-justify-center tw-gap-2">
        <TabsList intent="background">
          <TabsTrigger value="monthly" intent="background" onClick={() => setPeriod('monthly')}>
            Monthly
          </TabsTrigger>
          <TabsTrigger value="quarterly" intent="background" onClick={() => setPeriod('quarterly')}>
            <div className="tw-mr-2">Quarterly</div>
          </TabsTrigger>
          <TabsTrigger value="annually" intent="background" onClick={() => setPeriod('annually')}>
            <div className="tw-mr-2">Annually</div>
          </TabsTrigger>
        </TabsList>
      </div>
    </Tabs>
  )
}
